import * as React from 'react';
/**
 *
 * Original name: signable document
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29939%3A6944
 *
 */
export const SignableDocumentPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M13.813 56V8.005h24.693a5 5 0 0 1 3.52 1.45l3.137 3.11 2.638 2.507a7 7 0 0 1 2.177 5.073V32.01l-.017 2.198h-4l.017-2.206v-10.99H36.97v-9.007H17.813V52h28.015v-.01h4l-.03 4.01H13.812Z", fill: "currentColor" }),
    React.createElement("path", { d: "M32.583 45.138H25.37v-4h7.213v4Zm9.95 0h-7.214v-4h7.214v4Zm2.719 0h7.214v-4h-7.214v4Zm-11.613-12.63 3.094-3.094-2.828-2.828-3.095 3.094-3.094-3.094-2.828 2.828 3.094 3.094-3.094 3.095 2.828 2.828 3.095-3.094 3.094 3.094 2.828-2.828-3.094-3.095Z", fill: "currentColor" })));
